import { useSelector } from 'react-redux';
export function useSchemaSamples(id: number) {
  const { flatSamples, flatSchemas, nestedSchemas, lastUpdated, nestedSamples } = useSelector(
    (state: any) => state.schemaSpecs,
  );

  return {
    flatSamples: flatSamples[id],
    flatSchemas: flatSchemas[id],
    nestedSchemas: nestedSchemas[id],
    nestedSamples: nestedSamples[id],
    lastUpdated,
  };
}
